export interface StatusIconConfigModel {
  text: string;
  icon?: string;
  externalIcon?: boolean;
  light: {
    bg: string;
    color: string;
  };
  dark: {
    bg: string;
    color: string;
  };
}
